var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjects(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200.426,
    height: 224.741,
    viewBox: "0 0 200.426 224.741",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2035",
    "data-name": "Rectangle 2035",
    width: 200.426,
    height: 215.115,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2033",
    "data-name": "Rectangle 2033",
    width: 6.321,
    height: 6.332,
    fill: "#f6a46c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22207",
    "data-name": "Group 22207",
    transform: "translate(-840.57 -209.637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11341",
    "data-name": "Path 11341",
    d: "M152.018,352.337c0,4.264-34.03,7.72-76.009,7.72S0,356.6,0,352.337s34.03-7.721,76.009-7.721,76.009,3.457,76.009,7.721",
    transform: "translate(886.023 74.32)",
    fill: "#7586ec",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22206",
    "data-name": "Group 22206",
    transform: "translate(840.57 209.637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22205",
    "data-name": "Group 22205",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22204",
    "data-name": "Group 22204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22203",
    "data-name": "Group 22203",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11378",
    "data-name": "Path 11378",
    d: "M547.783,1107.687h0c-.877.549-2.237-.07-3.017-1.374l-16.68-45.2,3.134-1.963,16.733,45.288c.76,1.27.684,2.714-.17,3.249",
    transform: "translate(-445.221 -892.954)",
    fill: "#262d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2029",
    "data-name": "Rectangle 2029",
    width: 3.975,
    height: 63.717,
    transform: "translate(83.303 103.461)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11379",
    "data-name": "Path 11379",
    d: "M460.124,793.3h21.232a2.935,2.935,0,1,0,0-5.869H460.124a2.935,2.935,0,0,0,0,5.869",
    transform: "translate(-385.45 -663.873)",
    fill: "#262d4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11380",
    "data-name": "Path 11380",
    d: "M352.355,1096.893h0c.877.549,2.237-.07,3.017-1.374l28.243-47.208-3.134-1.963-28.3,47.3c-.76,1.27-.684,2.714.17,3.249",
    transform: "translate(-296.481 -882.159)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11381",
    "data-name": "Path 11381",
    d: "M563.055,1096.893h0c-.877.549-2.237-.07-3.017-1.374l-28.243-47.208,3.134-1.963,28.3,47.3c.76,1.27.684,2.714-.17,3.249",
    transform: "translate(-448.348 -882.159)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2030",
    "data-name": "Rectangle 2030",
    width: 166.11,
    height: 121.19,
    transform: "translate(1.725 3.736)",
    fill: "#d2e4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11382",
    "data-name": "Path 11382",
    d: "M226.207,381.232H104.567a3.413,3.413,0,1,1,0-6.825h121.64a3.413,3.413,0,1,1,0,6.825",
    transform: "translate(-85.281 -315.657)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11383",
    "data-name": "Path 11383",
    d: "M237.592,523.19H103.2a2.042,2.042,0,0,1-2.043-2.042V489.64A2.043,2.043,0,0,1,103.2,487.6h134.4a2.043,2.043,0,0,1,2.043,2.043v31.508a2.043,2.043,0,0,1-2.043,2.042",
    transform: "translate(-85.281 -411.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2031",
    "data-name": "Rectangle 2031",
    width: 169.56,
    height: 3.693,
    transform: "translate(0 123.079)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2032",
    "data-name": "Rectangle 2032",
    width: 169.56,
    height: 3.736,
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11384",
    "data-name": "Path 11384",
    d: "M864.691,117.125l-4.929,14.819,12.991-8.668a15.654,15.654,0,0,0-8.061-6.151",
    transform: "translate(-724.852 -98.746)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11385",
    "data-name": "Path 11385",
    d: "M876.759,193.571l-13.689-7.113L875.9,177.88l.173.259a14.894,14.894,0,0,1,.835,15.155Zm-12.465-7.181,12.2,6.338a14.268,14.268,0,0,0-.77-13.98Z",
    transform: "translate(-727.641 -149.968)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11386",
    "data-name": "Path 11386",
    d: "M759.438,142.454a15.619,15.619,0,1,0,9.333,22.28l-14.276-7.418Z",
    transform: "translate(-623.34 -119.55)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11387",
    "data-name": "Path 11387",
    d: "M320.469,323.6H255.145a1.079,1.079,0,0,1-1.079-1.079v-.379a1.079,1.079,0,0,1,1.079-1.079h65.324a1.079,1.079,0,0,1,1.079,1.079v.379a1.079,1.079,0,0,1-1.079,1.079",
    transform: "translate(-214.199 -270.687)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11388",
    "data-name": "Path 11388",
    d: "M321.71,295.1H255.268a1.2,1.2,0,0,1-1.2-1.2v-.132a1.2,1.2,0,0,1,1.2-1.2H321.71a1.2,1.2,0,0,1,1.2,1.2v.132a1.2,1.2,0,0,1-1.2,1.2",
    transform: "translate(-214.199 -246.655)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11389",
    "data-name": "Path 11389",
    d: "M315.455,266.593h-60.4a.991.991,0,0,1-.992-.991v-.553a.992.992,0,0,1,.992-.992h60.4a.992.992,0,0,1,.991.992v.553a.991.991,0,0,1-.991.991",
    transform: "translate(-214.199 -222.622)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11390",
    "data-name": "Path 11390",
    d: "M311.856,238.088H255.007a.941.941,0,0,1-.941-.941v-.654a.941.941,0,0,1,.941-.941h56.849a.941.941,0,0,1,.941.941v.654a.941.941,0,0,1-.941.941",
    transform: "translate(-214.199 -198.59)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11391",
    "data-name": "Path 11391",
    d: "M304.481,209.584H255.007a.941.941,0,0,1-.941-.941v-.654a.941.941,0,0,1,.941-.941h49.474a.941.941,0,0,1,.941.941v.654a.941.941,0,0,1-.941.941",
    transform: "translate(-214.199 -174.559)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11392",
    "data-name": "Path 11392",
    d: "M318.233,181.079H255.057a.991.991,0,0,1-.991-.991v-.554a.991.991,0,0,1,.991-.991h63.176a.991.991,0,0,1,.991.991v.554a.991.991,0,0,1-.991.991",
    transform: "translate(-214.199 -150.527)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11393",
    "data-name": "Path 11393",
    d: "M318.233,152.574H255.057a.991.991,0,0,1-.991-.991v-.554a.991.991,0,0,1,.991-.991h63.176a.991.991,0,0,1,.991.991v.554a.991.991,0,0,1-.991.991",
    transform: "translate(-214.199 -126.495)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11394",
    "data-name": "Path 11394",
    d: "M119.288,323.6H102.37a1.216,1.216,0,0,1-1.216-1.216v-.1a1.216,1.216,0,0,1,1.216-1.216h16.918a1.216,1.216,0,0,1,1.216,1.216v.1a1.216,1.216,0,0,1-1.216,1.216",
    transform: "translate(-85.281 -270.687)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11395",
    "data-name": "Path 11395",
    d: "M119.856,295.1H102.37a1.216,1.216,0,0,1-1.216-1.216v-.1a1.216,1.216,0,0,1,1.216-1.216h17.486a1.216,1.216,0,0,1,1.216,1.216v.1a1.216,1.216,0,0,1-1.216,1.216",
    transform: "translate(-85.281 -246.655)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11396",
    "data-name": "Path 11396",
    d: "M121.1,266.593H102.369a1.216,1.216,0,0,1-1.216-1.216v-.1a1.216,1.216,0,0,1,1.216-1.216H121.1a1.216,1.216,0,0,1,1.216,1.216v.1a1.216,1.216,0,0,1-1.216,1.216",
    transform: "translate(-85.281 -222.622)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11397",
    "data-name": "Path 11397",
    d: "M120.54,238.088H102.37a1.216,1.216,0,0,1-1.216-1.216v-.1a1.216,1.216,0,0,1,1.216-1.216H120.54a1.216,1.216,0,0,1,1.216,1.216v.1a1.216,1.216,0,0,1-1.216,1.216",
    transform: "translate(-85.281 -198.59)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11398",
    "data-name": "Path 11398",
    d: "M121.1,209.584H102.369a1.216,1.216,0,0,1-1.216-1.216v-.1a1.216,1.216,0,0,1,1.216-1.216H121.1a1.216,1.216,0,0,1,1.216,1.216v.1a1.216,1.216,0,0,1-1.216,1.216",
    transform: "translate(-85.281 -174.559)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11399",
    "data-name": "Path 11399",
    d: "M121.1,181.079H102.369a1.216,1.216,0,0,1-1.216-1.216v-.1a1.216,1.216,0,0,1,1.216-1.216H121.1a1.216,1.216,0,0,1,1.216,1.216v.1a1.216,1.216,0,0,1-1.216,1.216",
    transform: "translate(-85.281 -150.527)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11400",
    "data-name": "Path 11400",
    d: "M120.54,152.574H102.37a1.216,1.216,0,0,1-1.216-1.216v-.1a1.216,1.216,0,0,1,1.216-1.216H120.54a1.216,1.216,0,0,1,1.216,1.216v.1a1.216,1.216,0,0,1-1.216,1.216",
    transform: "translate(-85.281 -126.495)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11401",
    "data-name": "Path 11401",
    d: "M165.169,110.922H102.807a1.653,1.653,0,0,1,0-3.305h62.362a1.653,1.653,0,1,1,0,3.305",
    transform: "translate(-85.281 -90.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11402",
    "data-name": "Path 11402",
    d: "M150.691,444.64H102.738a1.584,1.584,0,0,1-1.584-1.585v-.137a1.584,1.584,0,0,1,1.584-1.584h47.952a1.584,1.584,0,0,1,1.585,1.584v.137a1.585,1.585,0,0,1-1.585,1.585",
    transform: "translate(-85.281 -372.083)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11403",
    "data-name": "Path 11403",
    d: "M1184.843,1259.764s.83,5.79,2.258,7.659a14.788,14.788,0,0,1,1.93,2.554c.895,1.764.4,4.391-.26,5.838-.339.743.024.74-.748.98a4.73,4.73,0,0,1-5.687-2.685,13.7,13.7,0,0,1-1.115-4.934c-.244-5.258-1.87-7.931-1.87-7.931Z",
    transform: "translate(-994.293 -1062.088)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11404",
    "data-name": "Path 11404",
    d: "M971.445,1276.642s-.513,6.53-.1,8.651c.223,1.136,1.463,3.475.894,4.545a2.863,2.863,0,0,1-1.219,1.336l-14.748.239c-.8.013-.272-.507.375-.986a29.714,29.714,0,0,1,5.3-2.95c.221-.107,1.025-.622,1.315-.8a10.22,10.22,0,0,0,2.11-1.874c1.059-1.186,1.151-6.936,1.151-6.936Z",
    transform: "translate(-805.879 -1076.317)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11405",
    "data-name": "Path 11405",
    d: "M976.014,714.733s-1.857,10.6-.638,17.552,7.072,71.373,7.072,71.373l6.5.369s1.364-26.911,1.119-30.653a58.3,58.3,0,0,0-2.174-10.005l.647-21.728L980.338,713.1Z",
    transform: "translate(-821.975 -601.201)",
    fill: "#262d4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11406",
    "data-name": "Path 11406",
    d: "M1005.22,696.389s5.121,7.752,6.341,14.168-.895,26.132,1.451,34.539c1.27,4.551,6.082,11.579,6.814,17.46s3.6,21.286,3.6,21.286l-6.5,1.3-15.109-38.473-11.851-34.773-3.036-17.909Z",
    transform: "translate(-832.065 -585.086)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11407",
    "data-name": "Path 11407",
    d: "M1195.554,1327.72a7.249,7.249,0,0,0,7.127-3c.9,1.768,1.34,4.405.677,5.858-.583,1.279-2.288,1.242-3.631,1.292a3.5,3.5,0,0,1-3.222-1.983,11.93,11.93,0,0,1-.952-2.172",
    transform: "translate(-1007.953 -1116.855)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11408",
    "data-name": "Path 11408",
    d: "M957.562,1338.811a13.28,13.28,0,0,0,8.4-.332c.416,1.185.967,2.672.675,3.53-.358,1.05-.868,1.287-1.318,1.3-3.563.094-13.05.222-15.766.258a.447.447,0,0,1-.345-.734c.674-.809,8.067-3.843,8.358-4.022",
    transform: "translate(-800.171 -1128.451)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11409",
    "data-name": "Path 11409",
    d: "M824.2,555.736c-.271-.578,2.594-1.364,2.686-1.987s-3.748-.272-3.941-.79c-.355-.955,4.183-.643,4.047-1.093s-4.8-1-4.388-1.841,4.776,1.077,4.845.53-4.219-1.416-4.266-2.6c-.025-.63,7.141,2.415,7.892,1.993s-1.186-3.2-.605-3.7,3.02,5.661,3.474,5.831,10.363,2.779,13.707,3.272c.282-1.132,2.8-7.363,3.039-8.431,1.963,1.111,4.465-.226,6.475.764-1.011,3.567-3.283,15.317-4.19,15.846-2.764,1.611-16.941-6.274-19.344-7.633s-4.222-.9-5.348-1.007c-1.746-.167-3.81,1.415-4.082.837",
    transform: "translate(-693.5 -460.516)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11410",
    "data-name": "Path 11410",
    d: "M993.718,303.275c-.731-3.325-1.448-6.671.481-10.323a9.376,9.376,0,0,1,7.38-5.027c8.846-1.05,6.955,7.208,19.319,9,3.842.556,7.411,1.089,10.618,3,5.792,3.45,7.978,8.984,4.137,18-9.405,22.077-31.91,2.893-35.342-1.012-3.406-3.875-6.121-11.494-6.592-13.634",
    transform: "translate(-837.148 -242.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11411",
    "data-name": "Path 11411",
    d: "M1005.122,453.123s4.467.507,7.138,3.413-4.319,26.267-4.8,29.966,4.49,14.355,4.49,14.355-17.287,3.048-21.821.053c0,0-.4-28.588.087-31.23s4.534-13.387,5.506-14.443,9.4-2.113,9.4-2.113",
    transform: "translate(-834.63 -382.021)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11412",
    "data-name": "Path 11412",
    d: "M1039.747,394.924s.035.2.1.536c.3,1.62,1.461,7,2.244,8.473.947,1.786-3.241,7.481-7.271,6.786-1.2-.207,1.014-5.233.908-5.766-.2-1.019-.48-2.41-.763-3.835l-.472-2.386c-.431-2.178-.783-3.959-.783-3.959Z",
    transform: "translate(-871.503 -332.828)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22202",
    "data-name": "Group 22202",
    transform: "translate(162.205 61.946)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22201",
    "data-name": "Group 22201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22200",
    "data-name": "Group 22200",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11413",
    "data-name": "Path 11413",
    d: "M1039.845,395.46c-.063-.338-.1-.536-.1-.536l-6.039-.15s.352,1.781.783,3.959c.151.762.311,1.573.47,2.373a5.661,5.661,0,0,0,2.884-1.443,7.607,7.607,0,0,0,2.184-3.242c-.074-.381-.137-.709-.183-.961",
    transform: "translate(-1033.708 -394.773)",
    fill: "#f6a46c"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11414",
    "data-name": "Path 11414",
    d: "M1015.754,304.24a7.127,7.127,0,0,1,4.247,2.645c1.784,2.3,3.707,9.425-.725,13.3s-8.812-.511-9.461-5.158-.518-10.952,5.939-10.784",
    transform: "translate(-851.143 -256.498)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11415",
    "data-name": "Path 11415",
    d: "M1002.378,352.8c.28,1.12,1.014,1.877,1.639,1.69s.907-1.246.627-2.367-1.014-1.877-1.639-1.69-.907,1.246-.627,2.367",
    transform: "translate(-844.998 -295.424)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11416",
    "data-name": "Path 11416",
    d: "M1031.611,303.75s5.788,6.645,8.509,6.958,3.078,3.912,3.078,3.912-.973-8.293-3.666-9.892-7.92-.978-7.92-.978",
    transform: "translate(-869.735 -255.987)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11417",
    "data-name": "Path 11417",
    d: "M1079.861,348.747c-.221,1.2.224,2.306.994,2.464s1.573-.689,1.795-1.892-.224-2.306-.994-2.464-1.574.689-1.795,1.892",
    transform: "translate(-910.366 -292.412)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11418",
    "data-name": "Path 11418",
    d: "M975.474,573.882l-6.98,1.021-2.068.3-9.655,1.412a1.029,1.029,0,0,0-.869,1.167l3.65,24.952a1.029,1.029,0,0,0,1.167.869l18.7-2.736a1.029,1.029,0,0,0,.869-1.167l-3.65-24.952a1.029,1.029,0,0,0-1.167-.869",
    transform: "translate(-805.897 -483.822)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11419",
    "data-name": "Path 11419",
    d: "M991.777,574.262a.208.208,0,0,1,.176-.236l7.8-1.141a.208.208,0,0,1,.236.176l.118.811-8.214,1.2Z",
    transform: "translate(-836.15 -482.988)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11420",
    "data-name": "Path 11420",
    d: "M1010.086,571.59a1.243,1.243,0,1,0,1.05-1.41,1.244,1.244,0,0,0-1.05,1.41m.441-.064a.8.8,0,1,1,.9.674.8.8,0,0,1-.9-.674",
    transform: "translate(-851.577 -480.698)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11421",
    "data-name": "Path 11421",
    d: "M991.875,579.368a.208.208,0,0,0-.1.208l.119.811,8.214-1.2a1.028,1.028,0,0,1-.868,1.166l-6.18.9a1.028,1.028,0,0,1-1.166-.868l-.119-.811a.208.208,0,0,1,.1-.208",
    transform: "translate(-836.149 -488.303)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11423",
    "data-name": "Path 11423",
    d: "M994.651,614.6l-6.777.692s.111,5.752-.006,6.413c0,0-11.589,3.212-16.432,4.084,0,0-2.205-1.25-3.1-1.647a21.645,21.645,0,0,0-3.821-.9c-.53-.069-.349.512.106.715a4.407,4.407,0,0,1,1.968,1.438,3.685,3.685,0,0,1-1.463-.121c-.506-.226-1.2-.7-1.214-.951s-.126-.844-.292-.812c-.042.008-.1.2-.156.409s-.111.394-.159.591c-.085.353-.183.868-.221,1.1a15.963,15.963,0,0,0,.282,2.5c.083.945.352,1.365.852,1.605a12.324,12.324,0,0,0,2.913.589,19.6,19.6,0,0,0,5.348-.529c.924-.1,15.681-1.567,15.681-1.567s5.866-.844,6.255-1.854.233-11.756.233-11.756",
    transform: "translate(-811.952 -518.164)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11424",
    "data-name": "Path 11424",
    d: "M1095.092,468.965s2.139,1.014,4.019,5.395c1.787,4.163,2.312,24.937,2.312,24.937l-7.089-1.182-3.6-9.686a17.765,17.765,0,0,1,1.836-17.667c1-1.366,1.917-2.19,2.524-1.8",
    transform: "translate(-918.281 -395.295)",
    fill: "#699dee"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.375e4490a1d9c167f72854b619af7dff.svg";
export { ForwardRef as ReactComponent };